import * as React from "react"
import { SaTitle } from "../saTitle/saTitle"
// @ts-ignore
import {saTestimonials,saTestimonialsTitleContainer,saTestimonialsSubtitle,saTestimonialsBackground} from './saTestimonials.module.scss'
import SaTestimonialsList from "./saTestimonialsList"
import { saInterfaceTestimonialsContainer } from "../saTypes"



export const SaTestimonials:React.FC<saInterfaceTestimonialsContainer> = ({ ...props }) => {


    let saStyle: object = {}

    if(props.image) {
      saStyle = {
        background: `url(${props.image.sourceUrl || ''})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }
    }

    return (
      <div className={'saContainer ' + saTestimonials}>

        <div className={saTestimonialsTitleContainer}>
          <SaTitle title={props.title} />
        </div>

        <div className={saTestimonialsSubtitle}
             dangerouslySetInnerHTML={{__html: props.text}}/>

        <div className={saTestimonialsBackground} style={saStyle}>
          {props.relationship && <SaTestimonialsList {...props.relationship} />}
        </div>


      </div>
    )

}
